// extracted by mini-css-extract-plugin
module.exports = {"contentTabs":"AdminTabs_contentTabs__QI4dP"};